import { AnyAction } from 'redux';

import { SET_FORM_DISPLAY_ERROR } from './constants';

type StateId = string;

interface FormSingleState {
  displayError?: boolean;
}

export type FormsState = Record<StateId, FormSingleState>;

export const initialFormState: FormsState = {};

export const formsReducer = (state = initialFormState, action: AnyAction) => {
  switch (action.type) {
    case SET_FORM_DISPLAY_ERROR:
      return {
        ...state,
        [action.stateId]: {
          displayError: action.displayError,
        },
      };

    default:
      return state;
  }
};
